/**************************************************
 * Nombre:       Tarjeta_Modulo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import imagen from '../../Recursos/ic_modulo.svg'
import {FiberManualRecord} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Modulo = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#fff'}}
        >

            <Grid container size={{xs: 2, sm: 2, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={imagen} width={!masSM ? 40 : 60} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 10, sm: 10, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontFamily: NEGRITA, fontSize: !masSM ? 24 : 30}}>
                    {item.nombre}
                </Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 1}}
            >

                {item.item.map((tema) => {
                    return (
                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography>
                                <FiberManualRecord sx={{width: 10, height: 10, pr: 1}}/>
                                {tema}</Typography>
                        </Grid>
                    )
                })}

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Modulo